import React from 'react';

import MoreInformation from '@components/more-information';

const PatentSiteDetailsInfo = ({ MoreInfoDataPointsMap }) => {
  return (
    <div
      style={{
        marginBottom: '200px'
      }}
    >
      <MoreInformation
        info={Object?.keys(MoreInfoDataPointsMap)?.map((a) => {
          return {
            title: MoreInfoDataPointsMap[a]?.value || null,
            heading: MoreInfoDataPointsMap[a]?.title || null
          };
        })}
        hideEditBtn
      />
    </div>
  );
};

export default PatentSiteDetailsInfo;
